const $$splitComponentImporter = () => import('/home/runner/work/zngly-corporate/zngly-corporate/wp-content/themes/zngly-corporate/frontend/src/routes/dash/crm/contacts/lists/$listId/route.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { requireUserPostCaps } from '@/Router';
import { CrmListSingleQuery, type CrmList_Single_Query, type CrmList_Single_Query$data } from '@/graphql/queries/CrmList.query';
import { RelayEnvironment } from '@/graphql/relay-env';
import { createFileRoute } from '@tanstack/react-router';
import { loadQuery } from 'react-relay';
type Props = {
  data?: CrmList_Single_Query$data;
  isFallback?: boolean;
};
export const Route = createFileRoute('/dash/crm/contacts/lists/$listId')({
  component: lazyRouteComponent($$splitComponentImporter, 'component', () => Route.ssr),
  beforeLoad: ({
    params
  }) => {
    requireUserPostCaps('crmList', 'edit_post', {
      to: '/dash/crm/crmLists'
    });
  },
  loader: ({
    params
  }) => {
    return loadQuery<CrmList_Single_Query>(RelayEnvironment, CrmListSingleQuery, {
      id: params.listId
    }, {
      fetchPolicy: 'store-or-network'
    });
  }
});